import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import DepartmentSetupBody from './DepartmentSetupBody';
import { activeEditVehicleColumn } from '../../actions/lookups';
import DepartmentListItem from './DepartmentListItem';
import { updateEditDepartment } from '../../actions/apiDepartmentUpdates';

const activeOptions = ['true', 'false'];

class DepartmentListItemContainer extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			errors: { addDepartmentPropertyError: false }, option_name: '',
		};
	}

	componentDidMount() {
		const id = Array.isArray(this.props.department_id)
			? this.props.department_id[0]
			: this.props.department_id;
		if (id) {
			this.props.updateEditDepartment(id);
		}
	}

	componentDidUpdate(prevProps) {
		const prevId = Array.isArray(prevProps.department_id)
			? prevProps.department_id[0]
			: prevProps.department_id;
		const id = Array.isArray(this.props.department_id)
			? this.props.department_id[0]
			: this.props.department_id;
		if (id && id !== prevId) {
			this.props.updateEditDepartment(id);
		}
	}

	render() {
		const editId = this.props.edit_department && this.props.edit_department.id;

		return (
			<div className="col-md-12">

				<div className="row">
					{editId > 0 ? <DepartmentListItem /> : ''}
				</div>
			</div>
		);
	}
}

const mappedActions = {
	updateEditDepartment,
};

function mapStateToProps(state) {
	return { edit_department: state.settings_admin.edit_department };
}

export default connect(mapStateToProps, mappedActions)(DepartmentListItemContainer);
